import { Avatar, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {  RootState } from '../../store';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import SideBarSkeleton from '../user/SideBarSkeleton';

import { useMenuItem } from '../../hooks/useMenuItem';


function UserPopup() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const { auth, user_avatar_uri } = useAuth()
    const isLoading = useSelector<RootState>(state => state.user.isUserLoading)
    const open = Boolean(anchorEl);
    const { t } = useTranslation()
    const { menu } = useMenuItem(22)
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };





    //Display loading skeleton
    if (isLoading) {
        return <SideBarSkeleton></SideBarSkeleton>
    }

    return (
        <>
            <Box display={'flex'} alignItems={'center'} gap={1}>
                <Avatar src={user_avatar_uri} sx={{ width: 36, height: 36, cursor: 'pointer' }} onClick={handleClick}></Avatar>
            </Box>

            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={(e, r) => r === 'backdropClick' ? handleClose() : null}
            >
                <Box display={'flex'} flexDirection={'column'} alignItems={'center'} p={2} gap={1}>
                    <Avatar src={user_avatar_uri} sx={{ width: 50, height: 50 }} ></Avatar>
                    <Typography variant='subtitle1'>{auth?.firstname}</Typography>
                    <Typography color='lightgray' variant='subtitle2'>{auth?.email}</Typography>
                </Box>

                <Divider></Divider>

                {
                    menu.map(m => (
                        <MenuItem disableRipple disableTouchRipple target={m.target} component={m?.link ? Link : 'li'} to={m?.link ?? ''} key={m.key} onClick={() => {
                            handleClose()
                            m.fn?.()
                        }}>
                            <ListItemIcon>
                                {m.icon}
                            </ListItemIcon>
                            <Typography variant='body2'>{t(m.key)}</Typography>
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    )
}

export default UserPopup